// src/layouts/PublicLayout.jsx
import React from 'react';
import { Outlet } from 'react-router-dom';

function PublicLayout() {
  return (
    <div>
      {/* No sidebar here */}
      <Outlet />
    </div>
  );
}

export default PublicLayout;
